import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MetaPreviewData } from '../../../../../../../models/meta-template/preview-interfaces/meta-preview-data.interface';
import { MetaCreativeComponent } from '../../../preview-common/meta-creative/meta-creative.component';
import { MetaPreviewCopy } from '../../../preview-common/meta-preview-copy';

/** Marketplace search results (mobile): a listing-sized card among the search results. */
@Component({
  selector: 'app-meta-marketplace-search-mobile',
  imports: [CommonModule, MetaCreativeComponent],
  templateUrl: './marketplace-search-mobile.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: [
    '../../../preview-common/facebook/marketplace-styles.scss',
    './marketplace-search-mobile.component.scss',
  ]
})
export class MetaMarketplaceSearchMobilePreviewComponent {
  @Input() data!: MetaPreviewData;

  readonly pageName = MetaPreviewCopy.FACEBOOK_PAGE_NAME;
  readonly avatar = MetaPreviewCopy.AVATAR;

  get headline(): string {
    return MetaPreviewCopy.headline(this.data);
  }
}